var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(!_vm.pack)?_c('span',{staticClass:"resize-loading"},[_c('span',{staticClass:"loader"})]):_vm._e(),(_vm.pack)?_c('package-form',{attrs:{"loading":_vm.loading,"packData":_vm.pack,"formErrors":_vm.formErrors},on:{"packSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }